import { httpRequest } from "../../../utils/HttpRequest";
import { IPage } from "../../../types/FmsTypes";
import { IIMaterielSearch, IMaterielParams, IMaterielDetail, IMaterielInsert, IMaterielUpdate, IMaterielDisable, IMaterielRemove } from "./materielTypes"
class MaterielService {
    async page(params: IIMaterielSearch) {
        const apiUrl = "/md/material/page"
        return await httpRequest.post<IPage<IMaterielDetail>>(apiUrl, params)
    }
    async insert(params: IMaterielInsert) {
        const apiUrl = "/md/material/insert"
        return await httpRequest.post<boolean>(apiUrl, params)
    }
    async update(params: IMaterielUpdate) {
        const apiUrl = "/md/material/update"
        return await httpRequest.post<boolean>(apiUrl, params)
    }
    async remove(params: IMaterielRemove) {
        const apiUrl = "/md/material/remove"
        return await httpRequest.post<boolean>(apiUrl, params)
    }
    async disable(params: IMaterielDisable) {
        const apiUrl = "/md/material/disable"
        return await httpRequest.post<boolean>(apiUrl, params)
    }
}
const materielService = new MaterielService()
export {
    materielService
}